import svgPaths from "./svg-u9kv9tqycm";
import imgImage503 from "../../../assets/web-v3-images/4adf94c3ea26969800e87af61ba60af90dee4928.png";
import imgImage487 from "../../../assets/web-v3-images/4bbe745a0b83d3fffa3aed171a82fd6afb698c43.png";
import imgImage469 from "../../../assets/web-v3-images/53806bd0d0abad92abe034ba3d0e3a9d2ce07187.png";
import imgImage329 from "../../../assets/web-v3-images/d7a9eeceadd2aced41fcd8beb4dfc8595ba358b8.png";
import imgImage488 from "../../../assets/web-v3-images/956bb464bf8e781ebc44ce8a86dd750dfb59e162.png";
import imgImage395 from "../../../assets/web-v3-images/c75c6a222734b39e38794c0929974c8ff910f33a.png";
import imgImage489 from "../../../assets/web-v3-images/b6e57f66f5f54088d03efdcfa378f9085b3857cc.png";
import imgImage524 from "../../../assets/web-v3-images/41541279f77f5941922228030afb10c5748f4d5c.png";
import Headers from "@/component/Headers";
import bgButton from "../../../assets/images/bg-button-pz.png";
import iconHeader from "../../../assets/web-v3-images/icon-header.png";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { curStateAccount } from "@/Redux/selector";
function BgPage() {
  return (
    <div
      className="absolute h-[829px] left-0 top-0 w-[880px]"
      style={{
        backgroundImage:
          "linear-gradient(186.56deg, rgb(255, 128, 54) 1.7018%, rgb(220, 38, 1) 86.189%)",
      }}
    >
      <div
        className="absolute h-[1231px] left-[-20px] opacity-32 top-0 w-[918px]"
        data-name="image 503"
      >
        <img
          alt=""
          className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
          src={imgImage503}
        />
      </div>
      <div
        className="absolute left-[249px] size-[869px] top-[-40px]"
        data-name="image 487"
      >
        <img
          alt=""
          className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
          src={imgImage487}
        />
      </div>
      <div className="absolute flex h-[204px] items-center justify-center left-[-119px] top-[503px] w-[1118px]">
        <div className="-scale-y-100 flex-none rotate-180">
          <div
            className="h-[204px] pointer-events-none relative w-[1118px]"
            data-name="image 469"
          >
            <div className="absolute inset-0 overflow-hidden">
              <img
                alt=""
                className="absolute h-[352.65%] left-0 max-w-none top-[-252.55%] w-full"
                src={imgImage469}
              />
            </div>
            <div
              aria-hidden
              className="absolute border border-[rgba(255,255,255,0)] border-solid inset-0 shadow-[0px_4px_44.5px_0px_rgba(104,20,10,0.36)]"
            />
          </div>
        </div>
      </div>
      <div
        className="-translate-x-1/2 absolute h-[1433px] left-[calc(50%+243.5px)] mix-blend-screen top-[-644px] w-[1489px]"
        data-name="image 329"
      >
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <img
            alt=""
            className="absolute max-w-none object-cover size-full"
            src={imgImage329}
          />
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 1489 1433' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><rect x='0' y='0' height='100%' width='100%' fill='url(%23grad)' opacity='1'/><defs><radialGradient id='grad' gradientUnits='userSpaceOnUse' cx='0' cy='0' r='10' gradientTransform='matrix(-6.9953e-14 52.2 -57.396 -1.0383e-13 744.5 911)'><stop stop-color='rgba(0,0,0,0)' offset='0.62193'/><stop stop-color='rgba(0,0,0,1)' offset='1'/></radialGradient></defs></svg>\")",
            }}
          />
        </div>
      </div>
      <div
        className="absolute left-[346px] mix-blend-screen size-[675px] top-[43px]"
        data-name="image 488"
      >
        <img
          alt=""
          className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
          src={imgImage488}
        />
      </div>
      <div
        className="absolute flex inset-[25.08%_3.48%_33.74%_57.72%] items-center justify-center"
        style={{ containerType: "size" }}
      >
        <div className="flex-none h-[hypot(-0.303545cqw,99.6965cqh)] rotate-[0.17deg] w-[hypot(99.6965cqw,0.303545cqh)]">
          <div className="relative size-full" data-name="image 395">
            <div className="absolute inset-[0_-1.04%_-2.09%_-1.04%]">
              <img
                alt=""
                className="block max-w-none size-full"
                height="347.477"
                src={imgImage395}
                width="347.477"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[389.086px] items-center justify-center left-[412px] top-[200px] w-[502.668px]">
        <div className="flex-none rotate-[-9.3deg]">
          <div
            className="h-[319.444px] relative w-[457.066px]"
            data-name="image 489"
          >
            <img
              alt=""
              className="absolute inset-0 max-w-none object-bottom pointer-events-none size-full"
              src={imgImage489}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function Frame7() {
  const selectorAccount = useSelector(curStateAccount);
  // Tổng lượt còn lại của user = cộng dồn turn của mọi gói trong remainTurn
  // (từ API getTurnRemain), giống cách tính bên Home/GuessPriceCard.
  const turns = (selectorAccount?.remainTurn ?? []).reduce(
    (total, pack) => total + (pack?.turn ?? 0),
    0,
  );
  const { t } = useTranslation();
  return (
    <div className="[word-break:break-word] absolute content-stretch flex flex-col font-['Inter:Extra_Bold',sans-serif] font-extrabold gap-[8px] items-start left-[32px] not-italic top-[292px] w-[399px]">
      <p className="leading-[48px] min-w-full relative shrink-0 text-[#fef0c7] text-[40px] text-shadow-[0px_2px_4px_#b7220d] w-[min-content]">
        {t("your_turns")}
      </p>
      {/* Số lượt: 2 lớp glyph xếp chồng bằng grid — lớp dưới viền cam-đỏ + bóng
          3D (mép dưới đặc + glow), lớp trên tô gradient vàng như design. */}
      <p className="relative inline-grid shrink-0 whitespace-nowrap text-[180px] leading-[normal]">
        <span
          aria-hidden="true"
          className="col-start-1 row-start-1 text-[#E8461F] [-webkit-text-stroke:10px_#E8461F] text-shadow-[0px_6px_16px_#b7220d,0px_4px_0px_#bc2906]"
        >
          {turns}
        </span>
        <span
          className="col-start-1 row-start-1 bg-clip-text text-transparent"
          style={{
            backgroundImage:
              "linear-gradient(176.058deg, rgb(255, 248, 210) 19.245%, rgb(254, 238, 149) 77.675%)",
          }}
        >
          {turns}
        </span>
      </p>
    </div>
  );
}

export function ComponentButtonTabPackage({ key, isActive, name, onClick }) {
  return (
    <div
      key={key}
      className={`content-stretch flex items-center relative shrink-0 w-[400px] btn-click-active ${isActive ? "" : "opacity-60"}`}
      onClick={onClick}
    >
      <img src={bgButton} alt="" />
      <p className="-translate-x-1/2 [word-break:break-word] absolute font-['Inter:Extra_Bold',sans-serif] font-extrabold leading-[1.12] left-1/2 not-italic text-[#fbf5da] text-[32px] text-center top-[calc(50%-36px)] whitespace-nowrap">
        {name.split(" ").map((item, index) => (
          <Fragment key={index}>
            {item}
            <br />
          </Fragment>
        ))}
      </p>
    </div>
  );
}

export function ComponentBestSaler() {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="absolute content-stretch flex flex-col items-end right-[-17px] top-[-15px]"
        data-name="Scarcity"
      >
        {/*  */}
        <div
          className="content-stretch flex items-start px-[16px] py-[8px] relative rounded-bl-[16px] rounded-tl-[16px] rounded-tr-[16px] shrink-0"
          style={{
            backgroundImage:
              "linear-gradient(167.6deg, rgb(255, 80, 64) 39.955%, rgb(219, 55, 40) 94.057%)",
          }}
          data-name="Scarcity"
        >
          <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[32px] not-italic relative shrink-0 text-[24px] text-white whitespace-nowrap">
            {t("best_seller")}
          </p>
        </div>
        {/*  */}
        <div className="flex items-center justify-center relative shrink-0">
          <div className="-scale-y-100 flex-none rotate-180">
            <div className="relative size-[16px]">
              <svg
                className="absolute block inset-0 size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 0H16V16L8 8L0 0Z"
                  fill="url(#paint0_linear_4_438)"
                  id="Rectangle 1456"
                />
                <defs>
                  <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id="paint0_linear_4_438"
                    x1="6.79248"
                    x2="13.8465"
                    y1="6.10547"
                    y2="15.9141"
                  >
                    <stop stopColor="#FF5040" />
                    <stop offset="1" stopColor="#DB3728" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function TabPackage({ dataTabsPackage, tabActive, setTabActive }) {
  return (
    // <div className="absolute content-stretch flex flex-col gap-[32px] items-start left-[-3px] top-[153px] w-[879px]">
    <div className="relative shrink-0 w-full">
      <div className="flex flex-row items-center">
        <div className="content-stretch flex gap-[16px] items-center px-[32px] relative size-full">
          {dataTabsPackage.map((item) => (
            <ComponentButtonTabPackage
              key={item.id}
              isActive={tabActive === item.id}
              name={item.name}
              onClick={() => setTabActive(item.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export function ContactInfoHelper({ tabActive }) {
  const { t, i18n } = useTranslation();
  return (
    <div className="-translate-x-1/2 relative content-stretch flex flex-col gap-[24px] h-[243px] items-start left-[calc(50%+0.5px)] p-[44px] w-[816px] mt-[8px]">
      <div className="-translate-x-1/2 absolute bottom-0 content-stretch flex flex-col items-start left-1/2 top-0 w-[816px]">
        <div
          className="aspect-[816/81] relative shrink-0 w-full"
          data-name="image 524"
        >
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img
              alt=""
              className="absolute h-[767.97%] left-[-7.14%] max-w-none top-[-125.25%] w-[114.29%]"
              src={imgImage524}
            />
          </div>
        </div>
        <div
          className="flex-[1_0_0] min-h-px relative w-full"
          data-name="image 526"
        >
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img
              alt=""
              className="absolute h-[272.83%] left-[-7.14%] max-w-none top-[-80.02%] w-[114.29%]"
              src={imgImage524}
            />
          </div>
        </div>
        <div
          className="aspect-[816/81] relative shrink-0 w-full"
          data-name="image 525"
        >
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img
              alt=""
              className="absolute h-[767.97%] left-[-7.14%] max-w-none top-[-506.73%] w-[114.29%]"
              src={imgImage524}
            />
          </div>
        </div>
      </div>
      <div className="[word-break:break-word] flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[#772917] text-[32px] tracking-[0.32px] whitespace-nowrap">
        <p className="leading-[normal]">{t("having_trouble")}</p>
      </div>
      <div className={`[word-break:break-word] font-['Inter:Medium',sans-serif] font-medium leading-[0] not-italic relative shrink-0 text-[#854a0e] ${i18n.language === "my" ? "text-[24px]" : "text-[28px]"} tracking-[0.28px] whitespace-nowrap`}>
        <p className="leading-[165.91999816894531%] mb-0">
          {/* <i class="fa fa-phone" aria-hidden="true"></i> */}
          {/* Dial *527# */}
          {/* {t("dialing")} 📩 */}
          {/* 527  */}
          {t("help_sending")}{" "}
        </p>
        {tabActive === "RETAIL" ? (
          ""
        ) : (
          <p className="leading-[165.91999816894531%]">{t("help_off")}</p>
        )}
      </div>
    </div>
  );
}

function ButtonBack() {
  return (
    <Headers className="absolute left-0 top-[10.29px] w-[880px] gap-[24px] px-[32px] py-[24px] pt-12" />
  );
}

export default function HeaderTurnRetailPackages({ children }) {
  return (
    <div className="relative size-full" data-name="mua turn/retail packages">
      <BgPage />
      <ButtonBack />

      <Frame7 />
      <div
        className="-translate-x-1/2 absolute h-[1656px] left-[calc(50%)] overflow-clip top-[522px] w-[880px]"
        data-name="Frame"
      >
        <div
          className="-translate-x-1/2 absolute bottom-[0.03%] left-1/2 top-0 w-[912.999px]"
          style={{ marginTop: "6px" }}
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 912.999 1500.5"
          >
            <g id="Vector">
              <path
                clipRule="evenodd"
                d={svgPaths.pf2d05f0}
                fill="url(#paint0_linear_4_444)"
                fillRule="evenodd"
              />
              <path
                clipRule="evenodd"
                d={svgPaths.pf2d05f0}
                fill="url(#paint1_linear_4_444)"
                fillRule="evenodd"
              />
              <path d={svgPaths.p2638a680} fill="url(#paint2_linear_4_444)" />
              <path d={svgPaths.p2638a680} fill="url(#paint3_linear_4_444)" />
            </g>
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_4_444"
                x1="456.5"
                x2="456.5"
                y1="-456.5"
                y2="730.5"
              >
                <stop stopColor="#FEECD6" />
                <stop offset="1" stopColor="#FFC478" />
              </linearGradient>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint1_linear_4_444"
                x1="456.5"
                x2="456.5"
                y1="0"
                y2="1402"
              >
                <stop stopColor="#FDECC5" />
                <stop offset="1" stopColor="#FEC790" />
              </linearGradient>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint2_linear_4_444"
                x1="456.5"
                x2="456.5"
                y1="-456.5"
                y2="730.5"
              >
                <stop stopColor="#FEECD6" />
                <stop offset="1" stopColor="#FFC478" />
              </linearGradient>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint3_linear_4_444"
                x1="456.5"
                x2="456.5"
                y1="0"
                y2="1402"
              >
                <stop stopColor="#FDECC5" />
                <stop offset="1" stopColor="#FEC790" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          className="-translate-x-1/2 absolute bottom-[92.05%] left-1/2 top-0 w-[912.999px]"
          data-name="Vector"
        >
          <div className="absolute inset-[-0.84%_-0.44%_-5.87%_-0.44%]" style={{ marginTop: "10px" }}>
            <img src={iconHeader} alt="" className="relative left-[21.5px]" />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
